import type { ExperienceDetailResult } from 'tripPlanner/api/types'
import type { DrawerExperience } from './ExperienceDetailView'

export function mapImageIds(imageIds: Array<string>): Array<App.Image> {
  return imageIds.map((id) => ({ id }))
}

export function mapExperienceDetailToDrawer(
  detail: ExperienceDetailResult,
): DrawerExperience {
  const { images, redemptionLocations: _, ...rest } = detail
  return { ...rest, images: mapImageIds(images) }
}
